import { Component, ComponentInterface, h, Host } from "@stencil/core";

@Component({
    tag: "uic-list-separator",
    styleUrl: "list-separator.scss"
})
export class ListSeparator implements ComponentInterface {
    render() {
        return <Host role='separator'></Host>;
    }
}
